<div id="map" class="map-host"></div>




<div
  #menuAnchor
  style="position: fixed; visibility: hidden;"
  [matMenuTriggerFor]="markerMenux"
></div>
<div
  #menuAnchor2
  style="position: fixed; visibility: hidden;"
  [matMenuTriggerFor]="markerMenuBetweenSegments"
></div>

<mat-menu #markerMenux="matMenu">
  <button mat-menu-item (click)="onMenuAction('delete')"><mat-icon>delete</mat-icon>Delete</button>
  <button mat-menu-item (click)="onMenuAction('cut')"><mat-icon>content_cut</mat-icon>Cut</button>
</mat-menu>

<mat-menu #markerMenuBetweenSegments="matMenu">
  <button mat-menu-item (click)="onMenuAction('merge')"><mat-icon>merge_type</mat-icon>Merge</button>
</mat-menu>